<template>
  <div>
    <!-- <div class="text-secondary mt-3 text-end">
      Расчет сохранен: 22.12.2020 14:32:12
    </div> -->
    <h2 class="mt-4">Предмет лизинга</h2>
    <div class="hr mt-2"></div>
    <div class="row mt-3">
      <div class="col-md-8 col-lg-6">
        <div class="form-group mb-3 form-floating">
          <input
            class="form-control"
            :value="localLeasing.KPPL_Name"
            placeholder="Предмет лизинга"
            disabled
          />
          <label>Предмет лизинга</label>

          <!-- <select class="form-control form-select" disabled>
            <option>Легковой транспорт</option>
            <option>Легковой транспорт 1</option>
            <option>Легковой транспорт 2</option>
          </select>
          <label>Тип ПЛ</label> -->
        </div>
        <!-- <div class="form-group mb-3 form-floating">
          <select class="form-control form-select">
            <option>BMW</option>
            <option>BMW 1</option>
            <option>BMW 2</option>
          </select>
          <label>Марка</label>
        </div> -->
        <!-- <div class="form-group mb-3 form-floating">
          <input class="form-control" value="Х5" placeholder="Placeholder" />
          <label>Модель</label>
        </div> -->
        <!-- <div class="form-group mb-3 form-floating">
          <select class="form-control form-select">
            <option>10</option>
            <option>11</option>
            <option>12</option>
          </select>
          <label>Количество</label>
        </div> -->
        <!-- <div class="form-group mb-3 form-floating">
          <select class="form-control form-select">
            <option>3 897 000</option>
            <option>3 897 001</option>
            <option>3 897 002</option>
          </select>
          <label>Стоимость за единицу</label>
        </div> -->
        <!-- <div class="form-group mb-3 form-floating">
          <select class="form-control form-select">
            <option>Московская область</option>
            <option>Московская область 1</option>
            <option>Московская область 2</option>
          </select>
          <label>Регион эксплуатации</label>
        </div> -->
        <!-- <div class="form-group mb-3 form-floating">
          <select class="form-control form-select">
            <option>2019</option>
            <option>2020</option>
            <option>2021</option>
          </select>
          <label>Год выпуска</label>
        </div> -->
        <!-- <div class="form-group mb-3">
          <label>
            <input type="radio" name="radiogroup" checked /><span>Новый</span>
          </label>
        </div>
        <div class="form-group mb-3">
          <label>
            <input type="radio" name="radiogroup" /><span>Подержанный</span>
          </label>
        </div> -->
        <div class="form-group mb-3 form-floating">
          <input
            class="form-control"
            :value="localLeasing.KPPL_SupplierName"
            placeholder="Наименование (ИНН) поставщика"
            disabled
          />
          <label>Наименование (ИНН) поставщика</label>
        </div>
        <div
          class="form-group form-floating"
          :class="{
            'mb-3':
              localLeasing?.LeasingSubjectPrice &&
              localLeasing?.LeasingSubjectPriceBase &&
              localLeasing.LeasingSubjectPrice > 0 &&
              localLeasing.LeasingSubjectPrice <
                localLeasing.LeasingSubjectPriceBase,
          }"
        >
          <input
            class="form-control"
            :value="moneyMask(localLeasing.LeasingSubjectPriceBase)"
            placeholder="Полная стоимость"
            disabled
          />
          <label>Полная стоимость</label>
        </div>
        <div
          v-if="
            localLeasing?.LeasingSubjectPrice &&
            localLeasing?.LeasingSubjectPriceBase &&
            localLeasing.LeasingSubjectPrice > 0 &&
            localLeasing.LeasingSubjectPrice <
              localLeasing.LeasingSubjectPriceBase
          "
          class="form-group form-floating"
        >
          <input
            class="form-control"
            :value="moneyMask(localLeasing.LeasingSubjectPrice)"
            placeholder="Стоимость со скидкой"
            disabled
          />
          <label>Стоимость со скидкой</label>
        </div>
        <!-- <RouterLink class="text-decoration" to=""
          >Добавить предмет лизинга</RouterLink
        > -->
      </div>
    </div>

    <h2 class="mt-4">Калькулятор</h2>
    <div class="hr mt-2"></div>
    <div class="row mt-3">
      <div class="col-md-8 col-lg-6 mb-3">
        <!-- <div class="form-group mb-3 form-floating">
          <input
            class="form-control"
            :value="leasing.Adv"
            placeholder="Placeholder"
          />
          <label>Аванс, %</label>
        </div> -->

        <div class="form-group mb-3">
          <div class="form-floating">
            <input
              type="number"
              class="form-control"
              v-model.number="localLeasing.Adv"
              min="20"
              max="100"
              step="1"
              placeholder="Аванс"
              @change="validateAdv"
              :disabled="loadingUpdate || loading"
            />
            <label>Аванс, % — введите или выберите ползунком</label>
          </div>

          <input
            type="range"
            class="form-range mt-2"
            v-model.number="localLeasing.Adv"
            min="20"
            max="100"
            :disabled="loadingUpdate || loadingDownloadKP || loading"
          />
          <!-- <div
            class="d-flex justify-content-between text-secondary"
            style="font-size: 12px"
          >
            <span>20%</span><span>100%</span>
          </div> -->
        </div>

        <!-- Срок лизинга -->
        <div class="form-group mb-1">
          <div class="form-floating">
            <input
              type="number"
              class="form-control"
              v-model.number="localLeasing.SL"
              min="12"
              max="60"
              step="1"
              placeholder="Срок лизинга"
              @change="validateSL"
              :disabled="loadingUpdate || loadingDownloadKP || loading"
            />
            <label>Срок лизинга, мес — введите или выберите ползунком</label>
          </div>

          <input
            type="range"
            class="form-range mt-2"
            v-model.number="localLeasing.SL"
            min="12"
            max="60"
            :disabled="loadingUpdate || loadingDownloadKP || loading"
          />
          <!-- <div
            class="d-flex justify-content-between text-secondary"
            style="font-size: 12px"
          >
            <span>12 мес</span><span>60 мес</span>
          </div> -->
        </div>

        <!-- <div class="form-group mb-3 form-floating">
          <input
            class="form-control"
            :value="leasing.SL"
            placeholder="Placeholder"
          />
          <label>Срок лизинга, мес</label>
        </div> -->
        <div class="form-group mb-3">
          <label>
            <input
              type="radio"
              name="radiogroup"
              value="eq"
              v-model="localLeasing.PaymentPlanType"
              :disabled="loadingUpdate || loadingDownloadKP || loading"
            /><span>Равномерные платежи</span>
          </label>
        </div>
        <div class="form-group mb-3">
          <label>
            <input
              type="radio"
              name="radiogroup"
              value="desc"
              v-model="localLeasing.PaymentPlanType"
              :disabled="loadingUpdate || loadingDownloadKP || loading"
            /><span>Убывающие платежи</span>
          </label>
        </div>
        <!-- <h5 class="mb-0">Ежемесячные платежи: 55 301 руб.</h5>
        <div class="text-secondary">
          Сумма платежей за весь срок лизинга: 5 318 000 руб.
        </div> -->

        <div v-if="showResults">
          <div
            v-if="
              localLeasing.PaymentPlanType === 'eq' &&
              localLeasing.secondElement
            "
          >
            <h5 class="mb-0 text-secondary">
              Ежемесячные платежи: {{ moneyMask(localLeasing.secondElement) }}
            </h5>
            <h5>
              <!-- Сумма платежей за весь срок лизинга:
              {{ moneyMask(localLeasing.totalSum) }} -->

              Общая сумма договора лизинга:
              {{ moneyMask(localLeasing.totalSum) }}
            </h5>
          </div>

          <div
            v-else-if="
              localLeasing.PaymentPlanType === 'desc' &&
              localLeasing.secondElement &&
              localLeasing.lastPaymentSum
            "
          >
            <h5 class="mb-1 text-secondary">
              Первый платеж: {{ moneyMask(localLeasing.secondElement) }}
            </h5>
            <h5 class="mb-0 text-secondary">
              Последний платеж: {{ moneyMask(localLeasing.lastPaymentSum) }}
            </h5>
            <h5>
              Общая сумма договора лизинга:
              {{ moneyMask(localLeasing.totalSum) }}
            </h5>
          </div>
        </div>

        <div class="note mt-3">
          <!-- Выберите данный пункт для расчета Равномерные платежи/убывающих
          платежей, и персональный менеджер свяжется с Вами для уточнения
          деталей. -->

          Выберите тип платежей — равномерные или убывающие, чтобы рассчитать
          ежемесячные суммы. Затем нажмите «Обновить расчет», скачайте
          коммерческое предложение и оформите лизинг, если всё устраивает.
        </div>
      </div>

      <div class="col-md-4 col-lg-6 pe-0">
        <PaymentChart
          v-if="showResults"
          :items="localLeasing.Schedule"
          :divisor="15"
          :header="['№', 'Платеж, руб.']"
        />
      </div>

      <!-- <div class="col-md-8 col-lg-6 mb-3">
        <div class="block-blue p-4">
          <div class="h1 text-body">Выгодно!</div>
          <span
            >Скидка до 15% на этот предмет лизинга по специальному
            предложению</span
          >
        </div>
      </div> -->
    </div>

    <div v-if="error" class="login-alert p-3 text-center mt-2 mb-4">
      <div class="text-primary">Внимание!</div>
      <div>{{ error }}</div>
    </div>

    <div class="d-flex flex-wrap gap-2">
      <ui-button
        @click="update"
        :loading="loadingUpdate"
        :disabled="
          loadingUpdate ||
          loading ||
          loadingDownloadKP ||
          !(
            localLeasing.PaymentPlanType === 'eq' ||
            localLeasing.PaymentPlanType === 'desc'
          )
        "
        class="btn btn-ghost"
        >Обновить расчет</ui-button
      >

      <ui-button
        class="btn btn-base"
        @click="downloadKP"
        :loading="loadingDownloadKP"
        :disabled="
          !showResults ||
          loading ||
          loadingDownloadKP ||
          loadingUpdate ||
          !(
            (localLeasing.PaymentPlanType === 'eq' &&
              localLeasing.secondElement) ||
            (localLeasing.PaymentPlanType === 'desc' &&
              localLeasing.secondElement &&
              localLeasing.lastPaymentSum)
          )
        "
      >
        Получить подробное КП
      </ui-button>

      <ui-button
        class="btn btn-base"
        @click="next"
        :loading="loading"
        :disabled="
          !showResults ||
          loadingUpdate ||
          loadingDownloadKP ||
          loading ||
          !(
            (localLeasing.PaymentPlanType === 'eq' &&
              localLeasing.secondElement) ||
            (localLeasing.PaymentPlanType === 'desc' &&
              localLeasing.secondElement &&
              localLeasing.lastPaymentSum)
          )
        "
      >
        Перейти к оформлению
      </ui-button>
    </div>

    <ui-modal v-if="phoneEdit" :close="modalClose">
      <div class="modal-header">
        <h5 class="modal-title">Укажите ваш телефон</h5>
        <button class="btn-close" type="button" @click="modalClose"></button>
      </div>
      <div class="modal-body">
        <p>Номер телефона обязателен для оформления заявки.</p>

        <ui-input-box-floating class="mt-3" :error="errors.phone">
          <ui-input
            v-maska
            data-maska="+7 (###) ###-##-##"
            v-model="phone"
            class="form-control"
            placeholder="Номер выплатного дела"
          />
          <ui-input-label>Телефон</ui-input-label>
        </ui-input-box-floating>

        <div v-if="errors.phone" class="login-alert p-3 text-center mt-3">
          <div class="text-primary">Внимание!</div>
          <span>{{ errors.phone }}</span>
        </div>

        <ui-button
          @click="send"
          class="btn-base mt-3 me-2"
          :loading="loadingSend"
          :disabled="loadingSend"
          >Продолжить</ui-button
        >
      </div>
      <!-- <div class="modal-footer"></div> -->
    </ui-modal>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { postApi, moneyMask, downloadBase64FilePdf } from "@/run";
import { useRoute } from "vue-router";

import PaymentChart from "@/component/chart/PaymentChart.vue";

const route = useRoute();

const props = defineProps({
  leasing: {
    type: Object,
    required: true,
  },
  setLeasing: Function,
  setStatus: Function,
});

// локальная копия лизинга
const localLeasing = ref({
  ...props.leasing,
  Adv: props.leasing?.Adv ?? 0,
  SL: props.leasing?.SL ?? 1,
  PaymentPlanType: props.leasing?.PaymentPlanType ?? null,
  // если есть другие поля, их тоже можно добавить:
});

// валидация аванса
const validateAdv = () => {
  if (localLeasing.value.Adv == null) localLeasing.value.Adv = 20;
  if (localLeasing.value.Adv < 20) localLeasing.value.Adv = 20;
  if (localLeasing.value.Adv > 100) localLeasing.value.Adv = 100;
};

// валидация срока
const validateSL = () => {
  if (localLeasing.value.SL == null) localLeasing.value.SL = 12;
  if (localLeasing.value.SL < 12) localLeasing.value.SL = 12;
  if (localLeasing.value.SL > 60) localLeasing.value.SL = 60;
};

const showResults = ref(true);
const loading = ref(false);
const error = ref(false);

const errors = ref([]);

const phone = ref('+7');
const phoneEdit = ref(false);
const loadingSend = ref(false);

const modalClose = () => (phoneEdit.value = false);

const send = () => {
  errors.value = [];
  loadingSend.value = true;
  postApi("/leasing/phoneEdit", {
    phone: phone.value,
  })
    .then((response) => {
      if (response?.errors) {
        errors.value = response.errors;
      } else if (response?.error) {
        errors.value = { phone: response.error };
      } else if (response?.status) {
        phoneEdit.value = false;
        next();
      }
    })
    .finally(() => {
      loadingSend.value = false;
    });
};

const loadingUpdate = ref(false);
const loadingDownloadKP = ref(false);

const next = () => {
  loading.value = true;
  error.value = false;
  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 1,
  })
    .then((response) => {
      if (response?.error) {
        if (response?.phoneEdit) {
          phoneEdit.value = true;
        } else {
          error.value = response.error;
        }
      } else {
        response.Status && props.setStatus(response.Status);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

// скрываем блок при смене типа платежей
watch(
  () => [
    localLeasing.value.PaymentPlanType,
    localLeasing.value.Adv,
    localLeasing.value.SL,
  ],
  ([newType, newAdv, newSL], [oldType, oldAdv, oldSL]) => {
    if (newType !== oldType || newAdv != oldAdv || newSL != oldSL) {
      showResults.value = false;
    }
  }
);

// следим за null и заменяем на 0
watch(
  () => localLeasing.value.Adv,
  (newVal) => {
    if (newVal == null) localLeasing.value.Adv = 0;
  }
);

watch(
  () => localLeasing.value.SL,
  (newVal) => {
    if (newVal == null) localLeasing.value.SL = 0;
  }
);

const update = () => {
  error.value = false;
  loadingUpdate.value = true;
  postApi("/leasing/update", {
    id: route.params.id,
    SL: localLeasing.value.SL,
    Adv: localLeasing.value.Adv,
    PaymentPlanType: localLeasing.value.PaymentPlanType,
  })
    .then((response) => {
      showResults.value = true;
      if (response.leasing) {
        localLeasing.value = response.leasing;
        props.setLeasing(response.leasing);
      }

      if (response?.responseCalc?.errors) {
        error.value = response.responseCalc.errors;
      }
    })
    .finally(() => {
      loadingUpdate.value = false;
    });
};

const downloadKP = () => {
  error.value = false;
  loadingDownloadKP.value = true;
  postApi("/leasing/downloadKP", {
    id: route.params.id,
  })
    .then((response) => {
      if (response.error) {
        error.value = response;
      } else {
        downloadBase64FilePdf(
          response,
          "КП_" +
            ["Id", "KPPL_Name", "KPPL_SupplierName", "Adv", "SL"]
              .map((key) => localLeasing.value[key])
              .filter(Boolean)
              .join("_")
              .replace(/\s+/g, "_")
              .replace(/[^а-яА-Яa-zA-Z0-9-_]/g, "")
        );
      }
    })
    .finally(() => {
      loadingDownloadKP.value = false;
    });
};
</script>